import { useState, useEffect } from "react";

const useForm = (callback, validate) => {
  const [values, setValues] = useState({
    fullname: "",
    email: "",
    github: "",
    interest: "beginner_no_exp",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Normalize GitHub input - extract username from URL if provided
    let normalizedValue = value;
    if (name === 'github' && value.trim()) {
      const githubUrlMatch = value.trim().match(/(?:https?:\/\/)?(?:www\.)?github\.com\/([a-zA-Z0-9](?:[a-zA-Z0-9]|-(?=[a-zA-Z0-9])){0,38})\/?$/);
      if (githubUrlMatch) {
        normalizedValue = githubUrlMatch[1];
      }
    }
    
    setValues({
      ...values,
      [name]: normalizedValue,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    setShowSuccess(false);
    const validationErrors = validate(values);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
    }
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      const submitData = async () => {
        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
        const endpoint = `${apiUrl}/waitlist/entries/`;

        const payload = {
          ...values,
        };

        console.log("Submitting payload:", JSON.stringify(payload, null, 2));

        try {
          const response = await fetch(endpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          console.log("Response status:", response.status);
          console.log("Response ok:", response.ok);

          if (!response.ok) {
            const errorData = await response.json();
            console.error("Submission error:", errorData);
            
            // Handle specific error cases
            let errorMessage = "Submission failed. Please try again.";
            if (errorData.email && errorData.email.includes("already exists")) {
              errorMessage = "This email is already registered on our waitlist.";
            } else if (errorData.email) {
              errorMessage = errorData.email[0] || errorMessage;
            } else if (errorData.detail) {
              errorMessage = errorData.detail;
            }
            
            setErrors({ api: errorMessage });
            setShowSuccess(false);
            setIsSubmitting(false);
            return;
          }

          // Success case
          const responseData = await response.json();
          console.log("Submission successful! Response:", responseData);
          setErrors({}); // Clear any previous errors
          setShowSuccess(true);
          setIsSubmitting(false);
          
          // Reset form after successful submission
          setValues({
            fullname: "",
            email: "",
            github: "",
            interest: "beginner_no_exp",
          });
          
          // Hide success message after 5 seconds
          setTimeout(() => {
            setShowSuccess(false);
          }, 5000);

        } catch (error) {
          console.error("Network or other error:", error);
          setErrors({ api: "Network error. Please check your connection and try again." });
          setShowSuccess(false);
          setIsSubmitting(false);
        }
      };

      submitData();

    } else if (isSubmitting) {
      setIsSubmitting(false);
    }
  }, [errors, isSubmitting, values]);

  return { handleChange, handleSubmit, values, errors, showSuccess };
};

export default useForm;
